/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { Injectable } from '@angular/core';
import { ResourceInterface } from '@app/shared/models/resource.interface';
import { HttpClient } from '@angular/common/http';
import { ApiQuery } from '@app/core/http/api-query';
import { Observable } from 'rxjs';
import { PaginatedResponse } from '@app/shared/models/paginated-response.model';
import { map } from 'rxjs/operators';
import { HttpResponse } from '@app/core';
import { RequestModel } from '@app/sales/requests/request.model';
import { Model } from '@app/shared/models/model.model';

@Injectable({
  providedIn: 'root',
})
export class RequestsService implements ResourceInterface {
  constructor(private http: HttpClient) {}

  index(query: ApiQuery = new ApiQuery()): Observable<PaginatedResponse> {
    return this.http.get('v1/enquiries', query.buildGetOptions()).pipe(
      map((response: HttpResponse) => {
        response.data = response.data.map((request: any) => {
          return new RequestModel().deserialize(request);
        });

        return new PaginatedResponse().deserialize(response);
      })
    );
  }

  update(request: RequestModel): Observable<RequestModel> {
    return this.http.put('v1/enquiries/' + request.id, request).pipe(
      map((response: HttpResponse) => {
        return new RequestModel().deserialize(response.data);
      })
    );
  }

  store(request: RequestModel): Observable<RequestModel> {
    return this.http.post('v1/enquiries', request).pipe(
      map((response: HttpResponse) => {
        return new RequestModel().deserialize(response.data);
      })
    );
  }

  show(id: number, query: ApiQuery = new ApiQuery()): Observable<Model> {
    return this.http.get('v1/enquiries/' + id, query.buildGetOptions()).pipe(
      map((response: HttpResponse) => {
        return new RequestModel().deserialize(response.data);
      })
    );
  }

  destroy(id: number): Observable<any> {
    return this.http.delete('v1/enquiries/' + id);
  }
}
